module.exports = __webpack_public_path__ + "img/pic_2_2.266d87aa.jpg";